var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.Media = MDB.Charts.Media || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

$.extend(MDB.Charts.Media, {
    generateUrl: function (mediaId, callback) {
        callback('/Media/DisplayMedia/' + mediaId);
    }
});


MDB.Charts.renderers.videoMedia = function (widget, chart, data, metadata) {
    var kConfig = metadata.KendoConfig;
    MDB.Charts.emptyChartAndMakeVisible(widget, chart);
    var tag = createTag();
    
    MDB.Charts.Media.generateUrl(kConfig.mediaId, function (url) {
        tag.prop({
            src: url,
            width: chart.width(),
            height: chart.height()
        });

        chart.append(tag);
    });
    
    function createTag() {
        if (kConfig.embed){
            return $('<iframe />', {
                frameborder: false
            });
        }

        var props = {};
        if (kConfig.withControls) {
            props.controls = true;
        }
        if (kConfig.autoplay) {
            props.autoplay = true;
        }
        
        return $('<video />', props);
    }
};

MDB.Charts.renderers.imageMedia = function (widget, chart, data, metadata) {
    var kConfig = metadata.KendoConfig;
    MDB.Charts.emptyChartAndMakeVisible(widget, chart);
    
    MDB.Charts.Media.generateUrl(kConfig.mediaId, function (url) {
        chart.css({
            'background-image': 'url(' + url + ')',
            'background-repeat': 'no-repeat',
            'background-size': 'contain',
            'background-position': 'center'
        });
    });
};

MDB.Charts.renderers.audioMedia = function (widget, chart, data, metadata) {
    var kConfig = metadata.KendoConfig;
    MDB.Charts.emptyChartAndMakeVisible(widget, chart);
    
    //Add a little bit of spacing to prevent the pause button from hitting the side of the  widget
    chart.css('left', '5px');
    
    $.ajax({
        url: '/Media/AudioPlayerFor/' + kConfig.mediaId,
        success: function (html) {
            chart.append(html);
            MDB.createAudioPlayer(chart.find('.audio-player'));  
        }
    });
};